import React from 'react';
export const EmotionalAnchor = () => {
  return <section className="w-full bg-light py-16 md:py-24 px-6" data-id="element-35">
      <div className="max-w-[820px] mx-auto text-center" data-id="element-36">
        <p className="font-playfair text-primary" style={{
        fontSize: 'clamp(28px, 4.2vw, 46px)',
        lineHeight: 1.25,
        letterSpacing: '-0.01em',
        margin: 0
      }} data-id="element-37">
          Your body is not broken.
          <br data-id="element-38" />
          <span className="italic text-medium" data-id="element-39">
            It has been trying to protect you.
          </span>
        </p>
      </div>
    </section>;
};